let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8MedQ")).then(() => parcelRequire('k78t5'));